import cx from "classnames";

function Icon( props: { i: string, className?: string, fw?: boolean } ) {
	return (
		<i className={ cx( "fa-light", props.i, props.className, props.fw ? "fa-fw" : "" ) } />
	)
}

function createComponent( icon: string ) {
	return ( props: any ) => {
		return (
			<Icon i={ icon } { ...props }></Icon>
		)
	}
}

export const LocationIcon = createComponent( "fa-light fa-location-dot" );
export const SpinnerIcon = createComponent( "fa-light fa-spinner animate-spin" );
export const ChevronUpIcon = createComponent( "fa-light fa-angle-up" );
export const ChevronDownIcon = createComponent( "fa-light fa-angle-down" );
export const ChevronLeftIcon = createComponent( "fa-light fa-angle-left" );
export const ChevronRightIcon = createComponent( "fa-light fa-angle-right" );
export const HouseIcon = createComponent( "fa-light fa-house" );
export const EuroIcon = createComponent( "fa-light fa-coins" );
export const InfoIcon = createComponent( "fa-light fa-circle-info" );
export const CheckIcon = createComponent( "fa-light fa-check" );
export const CloseIcon = createComponent( "fa-light fa-xmark" );
export const FilterIcon = createComponent( "fa-light fa-filter-list" );
export const UpDownIcon = createComponent( "fa-light fa-arrows-up-down" );
export const SortIcon = createComponent( "fa-light fa-sort" );
export const SettingsIcon = createComponent( "fa-light fa-ellipsis-vertical" );
export const ImageIcon = createComponent( "fa-light fa-image" );
export const ImagesIcon = createComponent( "fa-light fa-images" );
export const FileIcon = createComponent( "fa-light fa-file-magnifying-glass" );
export const VideoIcon = createComponent( "fa-light fa-brands fa-youtube" );
export const PanoramaIcon = createComponent( "fa-light fa-street-view" );
export const MinusIconLight = createComponent( "fa-light fa-minus" );
export const XMarkIconLight = createComponent( "fa-light fa-xmark" );

export const PlusIcon = createComponent( "fa-solid fa-plus" );
export const MinusIcon = createComponent( "fa-solid fa-minus" );
